<div class="layout-column settings-audit-log-detail">
  <div class="layout-row layout-align-start-center header padding-15">
    <span class="br-body-1 font-weight-600 flex title-text" translate>Description</span>
    <bringoz-button type="tertiary" (onClick)="onCancel()">
      <bringoz-icon iconName="close" class="close-icon"></bringoz-icon>
    </bringoz-button>
  </div>

  <div class="content padding-15">
    <div class="detail-section">
      <p>
        <ng-container *ngIf="record.rawRecord.metadata?.keys as settingKey; else noSettingDescription">
          {{ 'SETTINGS_AUDIT_LOG.DESCRIPTION_' + record.action | translate: {setting: settingKey} }}
        </ng-container>
        <ng-template #noSettingDescription>---</ng-template>
        <span *ngIf="record.rawRecord.reason"> — {{ record.rawRecord.reason }}</span>
      </p>
    </div>

    <div class="detail-section">
      <div class="raw-json-header">
        <h4 translate>Raw Payload</h4>
        <bringoz-button type="tertiary" (onClick)="copyJsonToClipboard()">
          {{ 'Copy JSON' | translate }}
        </bringoz-button>
      </div>
      <pre class="raw-json">{{ record.rawRecord | json }}</pre>
    </div>
  </div>
</div>
